export default "__VITE_ASSET__D4Q3wmaZ__"